import React, { Component } from 'react';
import { bool, string } from 'prop-types';

import Toggle from 'elements/Toggle/Toggle';

import styles from './togglesLayouts.css';

class ToggleScene extends Component {
  static propTypes = {
    darkBg: bool,
    greenBg: bool,
    label: string,
    withSideLabel: bool,
    withStatusLabel: bool,
    withBackgroundHandler: bool,
  }
  
  state = {
    isOn: false
  }

  handleToggleChange = isOn => this.setState(isOn);
  
  render () {
    const { darkBg, greenBg, label, withSideLabel, withStatusLabel, withBackgroundHandler } = this.props;
    const { isOn } = this.state;

    const customBackground = isOn && withBackgroundHandler ? '#e5f2e5' : null;
    
    return (
      <div className={styles.innerPreview} style={{backgroundColor: customBackground}}>
        <Toggle
          darkBg={darkBg}
          greenBg={greenBg}
          label={label}
          withSideLabel={withSideLabel}
          withStatusLabel={withStatusLabel}
          onChange={this.handleToggleChange}
        />
      </div>
    );
  }
}

export const Default = props => <ToggleScene {...props}/>;
export const WithBackground = props => <ToggleScene {...props} withBackgroundHandler />;




// WEBPACK FOOTER //
// ./src/containers/elements/Toggles/constants/togglesLayouts.js